import * as yup from "yup";

export const CreateBookingSchema = yup.object().shape({
  company: yup
    .object()
    .shape({
      id: yup.number().required(""),
      name: yup.string().required(""),
    })
    .required("Company obrigatória"),
  coworking: yup
    .object()
    .shape({
      id: yup.number().required(""),
      name: yup.string().required(""),
    })
    .required("Coworking obrigatório"),
  private_room: yup
    .object()
    .shape({
      id: yup.number().required(""),
      name: yup.string().required(""),
    })
    .required("Private Room obrigatório"),
  start_date: yup.string().required("Data obrigatória"),
  months: yup.string().required("Meses obrigatória"),
  take: yup.string().required("Porcentagem obrigatória"),
});
